import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=81f830b4&scoped=true&"
import script from "./GroupPage.vue?vue&type=script&lang=js&"
export * from "./GroupPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupPage.vue?vue&type=style&index=0&id=81f830b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f830b4",
  null
  
)

export default component.exports